<template>
  <el-dialog
    :visible.sync="show"
    :before-close="close"
    @open="openDialog"
    :close-on-click-modal="false"
  >
    <div slot="title" class="dia-tit">
      <i></i>
      <span v-text="categoryTitle"></span>
    </div>
    <!-- editData：{{editData}}
    <hr>
    formData：{{formData}}-->
    <el-form ref="formData" :model="formData" :rules="rules" label-width="120px">
      <el-form-item label="课程系列名：" prop="courseGoodsName">
        <el-input v-model="formData.courseGoodsName" placeholder="请输入课程系列（不可重名）" maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="课时单价：" prop="originalPrice">
        <el-input-number v-model="formData.originalPrice" placeholder="请输入课时单价" maxlength="20"></el-input-number>
        <span style="margin-left: 20px">元</span>
      </el-form-item>
      <el-form-item label="期课时量：" prop="termAmount">
        <el-input-number v-model="formData.termAmount" placeholder="请输入期课时量" maxlength="20"></el-input-number>
      </el-form-item>
      <el-form-item label="封面图片：">
        <el-upload
          class="avatar-uploader"
          :action="uploadImageUrl"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <!-- footer -->
    <el-row slot="footer">
      <el-button type="primary" @click="saveCategory()" class="dialog-btn">确 定</el-button>
      <el-button @click="close" type="info" class="dialog-btn">取 消</el-button>
    </el-row>
  </el-dialog>
</template>

<script>
/**
 * 弹出框-使用封装
 * @attribute show 弹出框状态
 * @attribute editData 根据有无 editData数据 动态渲染 dialog弹出框 数据 和 弹框标题
 * @attribute cascaderList  el-cascader 级联选择器数据
 * @function close 自定义弹窗关闭事件
 */
import { addCatalog, editCatalog } from '@/api/research/curriculum'

export default {
  props: {
    show: {
      default: false,
      type: Boolean
    },
    editData: {
      default: () => {
        return {}
      },
      type: Object
    },
  },
  watch: {
    show () {
      if (this.show) {
        if (this.$refs.formData) {
          this.$refs.formData.resetFields()
        }
      }
    }
  },
  data () {
    return {
      imageUrl: '',
      categoryTitle: '',
      formData: {},
      uploadImageUrl:process.env.VUE_APP_API_USERINFO + '/common/file/uploadMap',
      rules: {
        courseGoodsName: [
          { required: true, message: '课程系列名不能为空', trigger: 'blur' },
          { max: 20, message: '字数限制在20个字内', trigger: 'blur' }
        ],
        originalPrice:[{ required: true, message: '课时单价不能为空', trigger: 'blur'}],
        termAmount:[{ required: true, message: '单期课时量不能为空', trigger: 'blur'}],
      }
    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.body.fileUrl
      this.formData.cover = this.imageUrl
    },
    beforeAvatarUpload(file) {
      console.log(file.type)
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 10MB!');
      }
      return isJPG && isLt2M;
    },

    openDialog () {
      this.formData = {}
      this.imageUrl = ''
      if (this.editData !== null) {
        this.categoryTitle = '编辑课程系列'
        this.formData = { ...this.editData }
        this.imageUrl = this.formData.cover
      } else {
        this.categoryTitle = '新增课程系列'
      }
    },

    // 关闭弹窗
    close () {
      this.$emit('close')
    },

    // 保存
    saveCategory () {
      this.$refs['formData'].validate(valid => {
        if (valid) {
          if (this.editData !== null) {
            editCatalog({
              ...this.formData
            }).then(res => {
              if (res.state === 'success') {
                window.$msg('编辑成功')
                this.close()
                this.$emit('updateCourseCatalog')
              }
            })
          } else {
            addCatalog({
              ...this.formData
            }).then(res => {
              if (res.state === 'success') {
                window.$msg('新增成功')
                this.close()
                this.$emit('updateCourseCatalog')
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/dialog.scss";
/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
/deep/ .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
